import React from "react";
import { Box, Stack } from "@mui/material";
import CustomizationMenuPanel from "./CustomizationMenuPanel";
import CustomizationBody from "./CustomizationBody";

const MobileApp = () => {
  return (
    <Stack
      sx={{
        height: "calc(100vh - 202px)",
      }}
      direction={"row"}
    >
      <CustomizationMenuPanel />
      <Box sx={{ flex: 1, height: "100%" }}>
        <CustomizationBody />
      </Box>
    </Stack>
  );
};

export default MobileApp;
